'use client'

import { memo } from 'react'

import { ErrorServiceUnavailable } from '@/components/common/Error'

const VaultV2RiskDisclosuresError = () => {
  return <ErrorServiceUnavailable minHeight="100px" />
}

export default memo(VaultV2RiskDisclosuresError)
